import { Avatar, Typography } from "@material-ui/core";
import { Chip, Container, Grid } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import "./Aboutme.css";
const AboutMe = () => {
  return (
    <div>
      <Container className="about-Container">
        <div>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <div className="image-box">
                <Avatar
                  className="img-avatar"
                  alt="Remy Sharp"
                  src="https://i.ibb.co/wcX7MN6/66619451-2373035856298397-7928832343668686848-o.jpg"
                />
              </div>
              <div className="About-text">
                <Typography variant="h4">
                  <span style={{ color: "#ff0266" }}>i'm </span> Morshed Alam
                </Typography>
                <Typography variant="h6">
                  A self-motivated and enthusiastic web developer with a deep
                  interest in JavaScript. To work in the Software industry with
                  modern web technologies which provides me with ample
                  opportunities to enhance my skills and knowledge along with
                  contributing to the growth of the organization
                </Typography>
              </div>
            </Grid>

            <Grid item xs={12} md={6}>
              <div className="skills">
                <Typography variant="h4">
                  <span style={{ color: "#ff0266" }}>my </span> Skills Set
                </Typography>
                <div className="skill-bottom"></div>
                <div className="about-container-skill">
                  <Chip
                    className="tech"
                    label="JavaScript"
                    variant="outlined"
                  />
                  <Chip className="tech" label="Es6" variant="outlined" />
                  <Chip className="tech" label="React.js" variant="outlined" />
                  <Chip className="tech" label="Next.js" variant="outlined" />
                  <Chip className="tech" label="Node.js" variant="outlined" />
                  <Chip
                    className="tech"
                    label="Express.js"
                    variant="outlined"
                  />
                  <Chip className="tech" label="Redux.js" variant="outlined" />
                  <Chip className="tech" label="Mongodb" variant="outlined" />
                  <Chip className="tech" label="Node.js" variant="outlined" />
                  <Chip
                    className="tech"
                    label="Express.js"
                    variant="outlined"
                  />
                  <Chip className="tech" label="Redux.js" variant="outlined" />
                  <Chip className="tech" label="Mongodb" variant="outlined" />
                  <Chip className="tech" label="Firebase" variant="outlined" />
                  <Chip className="tech" label="Github" variant="outlined" />
                  <Chip className="tech" label="GitLab" variant="outlined" />
                  <Chip className="tech" label="Git" variant="outlined" />
                  <Chip className="tech" label="Vs Code" variant="outlined" />
                </div>
                <br />
                <br />
                <Typography variant="h4">
                  {" "}
                  <span style={{ color: "#ff0266" }}>what </span> can I do?
                </Typography>
                <div className="skill-bottom"></div>
                <Typography variant="h6">
                  I can develop complex full stack web applications like social
                  media applications or e-commerce sites
                </Typography>
                <br />
                <br />
                <Typography variant="h4">
                  {" "}
                  <span style={{ color: "#ff0266" }}>what </span> have I done?
                </Typography>
                <div className="skill-bottom"></div>
                <Typography variant="h6">
                  I have developed a dozen plus web applications.Among of
                  them,The most popular sites is called Red onion. The goal of
                  this application is to help people by order food and payment
                  by card from home.
                </Typography>
              </div>
            </Grid>
          </Grid>
        </div>
      </Container>
      <br />
      <br />
      <br />
      <div className="contact-container">
        <div className="contact-content">
          <span style={{ color: "#fff" }}>
            If you want to talk about a project, get in touch.
          </span>
          <div className="contact_border"></div>
          <div className="contact-box-button">
            <Link to="/Contacts_us">
              <button className="contact-button">Contact_Me</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
